// Mermaid chart sources + node→section link maps for the Architecture section.
// Kept in their own module so sections-architecture.tsx stays component-only
// (react-refresh) and so mermaid-charts.test.ts can validate the syntax.

export const ARCHITECTURE_CHART = `graph TB
  Client["Your browser"]
  Edge["Edge · Caddy / Traefik"]
  API["Orchestrator · NestJS API"]
  DB[("Postgres · source of truth")]
  Redis[("Redis · job queue")]
  Agent["Agent container · one per run"]
  Proto["Prototype serve · live preview"]
  GH["GitHub"]

  Client --> Edge --> API
  API --> DB
  API --> Redis
  API -. "Docker socket" .-> Agent
  API -. "Docker socket" .-> Proto
  Agent -. "clone, push, PR" .-> GH`;

// Node key → docs section. Clicking a tier jumps straight to its section.
export const ARCHITECTURE_LINKS = {
  Edge: 'architecture',
  API: 'architecture',
  DB: 'data-model',
  Redis: 'data-model',
  Agent: 'run-lifecycle',
  Proto: 'prototypes',
  GH: 'projects',
  Client: 'getting-started',
};

export const LIFECYCLE_CHART = `graph LR
  Brief["Brief handed off"]
  Queue["Queued"]
  Prov["Provisioning"]
  Stage["Pipeline stage"]
  Gate{"Gate: tests pass?"}
  Fail["Run fails"]
  PR["Push + open PR"]
  Risk["Risk recorded"]
  Merge["Auto-merge"]
  Review["Held: not mergeable"]

  Brief --> Queue --> Prov --> Stage --> Gate
  Gate -- "fail · budget left" --> Stage
  Gate -- "budget spent" --> Fail
  Gate -- "pass" --> PR --> Risk
  Risk -- "mergeable" --> Merge
  Risk -- "conflict / blocked" --> Review`;

export const LIFECYCLE_LINKS = {
  Stage: 'run-lifecycle',
  Gate: 'loop-gates',
  Fail: 'loop-gates',
  PR: 'run-lifecycle',
  Risk: 'automerge',
  Merge: 'automerge',
  Review: 'automerge',
};

// Issue state machine — the six states an issue moves through.
// Board sort order: proposed → review → failed → building → open → closed
// (Postgres enum declaration order; `orderBy: { state: 'asc' }` = no extra column).
export const ISSUE_STATE_CHART = `graph LR
  Proposed["proposed\n🟠 needs you"]
  Open["open\nidle / buildable"]
  Building["building\nrun in progress"]
  Review["review\n🟠 needs you"]
  Failed["failed\nresting"]
  Closed["closed\nterminal"]

  Proposed -- "Approve" --> Open
  Proposed -- "Dismiss" --> Closed
  Open -- "Run started" --> Building
  Building -- "PR opened" --> Review
  Building -- "Failed, budget left: auto-retry" --> Open
  Building -- "Failed 3 times: gave up" --> Failed
  Building -- "Cancelled: shelved" --> Proposed
  Review -- "PR merged" --> Closed
  Review -- "PR rejected" --> Failed
  Failed -- "Approve / Run again" --> Open
  Open -- "Close" --> Closed
  Failed -- "Close" --> Closed`;

export const ISSUE_STATE_LINKS: Record<string, string> = {
  Proposed: 'issues',
  Open: 'issues',
  Building: 'runs',
  Review: 'automerge',
  Failed: 'issues',
  Closed: 'issues',
};
